import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";
export const createPreferences = async (postData:any) => {
  try {
    return await post<ApiResponse<[]>>('/cleaner/preference', postData ).then((res)=> {
        if(res.success===true) {
            SuccessMessage("API.SUCCESS.PREFERENCE.ADD")
            return res
        }
    
    })
  }
  catch(e:any) {
    HandleApiError(e);
            return null
  }
};
